/**
 * Normalizes Hero component data from different sources into a consistent structure
 */
export const normalizeHeroFlattenImageData = ({
  livePreviewData,
  slotData,
  componentData,
  mediaCollectionIndex = 0
}) => {
  if (livePreviewData || componentData?.HeroFlattenImage || componentData?.component) {
    if (componentData?.component?.HeroFlattenImage) {
      const heroFlattenImageData = componentData?.component?.HeroFlattenImage;
      return {
        source: 'component',
        heroData: [heroFlattenImageData],
        entryId: heroFlattenImageData.id
      };
    }
    const heroFlattenImageData = livePreviewData || componentData?.component;
    return {
      source: 'component',
      heroData: [heroFlattenImageData],
      entryId: heroFlattenImageData.id
    };
  }

  if (slotData?.slot?.mediaCollections) {
    const mediaCollections = slotData?.slot?.mediaCollections || [];
    const fallbackMediaCollection = mediaCollections[0] || null;
    const mediaCollection = mediaCollections[mediaCollectionIndex] || fallbackMediaCollection;
    const mediaArray = mediaCollection?.media || [];

    if (mediaArray.length === 0) return null;

    const heroData = mediaArray.map((media) => {
      const desktopSource = media.sourceDesktop?.[0] || null;
      const mobileSource = media.sourceMobile?.[0] || null;

      let desktopHotspot = null;
      if (desktopSource?.hotspot) {
        desktopHotspot = {
          id: media.entryId,
          componentName: 'ImageHotspot',
          imageUrl: desktopSource.uri,
          hotspots: desktopSource.hotspot,
        };
      }

      let mobileHotspot = null;
      if (mobileSource?.hotspot) {
        mobileHotspot = {
          id: media.entryId,
          componentName: 'ImageHotspot',
          imageUrl: mobileSource.uri,
          hotspots: mobileSource.hotspot,
        };
      }

      let previewImage = null;
      if (desktopSource) {
        previewImage = {
          damDownloadedContent: {
            url: desktopSource.uri,
          },
          damContentSelector: {
            assetData: [
              {
                selectedImageUrl: desktopSource.uri,
              },
            ],
          },
          imageHotspot: desktopHotspot,
          sourceData: desktopSource,
        };
      }

      let mobilePreviewImage = null;
      if (mobileSource) {
        mobilePreviewImage = {
          damDownloadedContent: {
            url: mobileSource.uri,
          },
          damContentSelector: {
            assetData: [
              {
                selectedImageUrl: mobileSource.uri,
              },
            ],
          },
          imageHotspot: mobileHotspot,
          sourceData: mobileSource,
        };
      }

      let altText = null;
      if (desktopSource?.altText) {
        altText = desktopSource.altText;
      } else if (mobileSource?.altText) {
        altText = mobileSource.altText;
      }

      let link = null;
      if (desktopSource?.hyperlink) {
        link = desktopSource.hyperlink;
      } else if (mobileSource?.hyperlink) {
        link = mobileSource.hyperlink;
      }
      return {
        source: 'slot',
        id: media.entryId,
        title: media.title,
        altText,
        link,
        previewImage,
        mobilePreviewImage,
        shouldLoopVideo: media.isAutoplay || false,
        sourceData: {
          desktop: desktopSource,
          mobile: mobileSource,
        },
        componentName: 'HeroFlattenImage',
      };

    });

    return {
      source: 'slot',
      heroData,
      entryId: mediaCollection.entryId
    };

  }

  // No data available
  return {
    heroData: []
  };
};